// ** React Imports
import {useEffect, useRef, useState} from 'react'

// ** Custom Components
import Wizard from '@components/wizard'

// ** Steps
import Tyc from "./steps/tyc";
import PersonalInfo from "./steps/personal-info";
import SendingOTP from "./steps/sending-otp";
import ValidationOTP from "./steps/validation-otp";
import IdentityRecognition from "./steps/identity-recognition";
import axios from "axios";

const SignFormWizard = ({handleFinish, showTC, token, ids, client, setMobile, mobile, docId}) => {

    const ref = useRef(null);
    const [stepper, setStepper] = useState(null);
    const [typeOTP, setTypeOTP] = useState(null);
    const [dataOTP, setDataOTP] = useState(null);
    const [userToRegister, setUserToRegister] = useState({
        lastName: '',
        firstName: '',
        phoneNumber: '',
        documentType: '',
        documentNumber: '',
        birthdate: null,
        email: ''
    });

    const validateUserRegistered = async () => {
        return
        const validateCustomerRecord = await axios.post(`${process.env.REACT_APP_API_URL}/clients/validateCustomerRecord`, {
            token
        })
        if (validateCustomerRecord.data) {
            setDataOTP(validateCustomerRecord.data);
            localStorage.setItem(`client-document`, validateCustomerRecord.data.documentClient);
            localStorage.setItem(`client-name`, `${validateCustomerRecord.data.firstName} ${validateCustomerRecord.data.lastName}`);
        }
    }

    useEffect(() => {
        const visitorData = localStorage.getItem('visitor-data');
        const clientData = localStorage.getItem('client-data');
        if (visitorData || clientData) {
            localStorage.clear();
        }
        validateUserRegistered();
    }, []);

    useEffect(() => {
        if (userToRegister.email && userToRegister.phoneNumber && userToRegister.documentNumber && !dataOTP) {
            const dataReg = {
                id: null,
                email: userToRegister.email,
                phone: userToRegister.phoneNumber,
                documentClient: userToRegister.documentNumber
            };
            localStorage.setItem(`client-document`, JSON.stringify(dataReg));
            localStorage.setItem(`client-name`, `${userToRegister.firstName} ${userToRegister.lastName}`);
            setDataOTP(dataReg);
        }
    }, [userToRegister]);

    console.log("stepper: ", stepper)
    useEffect(() => {
        const clientName = localStorage.getItem('client-name');
        if (!showTC && stepper && clientName) {
            stepper.to(4);
        }
    }, [showTC, stepper])

    const onFinish = () => {
        handleFinish(true);
    }

    const steps = [
        /*{
            id: 'tyc',
            title: 'Términos y condiciones',
            subtitle: 'Aceptar términos y condiciones',
            content: <Tyc stepper={stepper} token={token} isMobile={mobile} docId={docId}/>
        },*/
        {
            id: 'validation-otp',
            title: 'Validación de código',
            subtitle: 'Valida el código enviado',
            content: <ValidationOTP token={token} stepper={stepper} dataOTP={dataOTP} isMobile={mobile} typeOTP={typeOTP}
                                    userToRegister={userToRegister} ids={ids} docId={docId}  onFinish={onFinish}/>
        }/*,
        {
            id: 'sign-form',
            title: 'Información personal',
            subtitle: 'Completa la información personal',
            content: <PersonalInfo stepper={stepper} userToRegister={userToRegister} token={token}
                                   setUserToRegister={setUserToRegister} setMobile={setMobile}
                                   onFinish={onFinish} docId={docId}/>
        }*/
        
        /*,
        {
            id: 'sending-otp',
            title: 'Validación de identidad',
            subtitle: 'Valida la identidad de datos',
            content: <SendingOTP stepper={stepper} dataOTP={dataOTP} showTC={showTC} setTypeOTP={setTypeOTP}/>
        }*/
        
        // {
        //     id: 'identity-recognition',
        //     title: 'Prueba de vida',
        //     subtitle: 'Validar prueba de vida',
        //     content: <IdentityRecognition stepper={stepper} client={client} userToRegister={userToRegister} onFinish={onFinish} ids={ids} />
        // }
    ]

    return (
        <div className='horizontal-wizard'>
            <Wizard instance={el => setStepper(el)} ref={ref} steps={steps}/>
        </div>
    )
}

export default SignFormWizard
